module.exports = __webpack_public_path__ + "static/media/bottom-direction.e1410d78.svg";